import { createAsyncThunk } from "@reduxjs/toolkit";
import api from "@/services/axios_custom";
import API_ENDPOINTS from "@/util/api";

// — Get All functionality rule 
export const fetchSecurityRuleFunctionalityList = createAsyncThunk(
  "securityRulesFunctionality/fetchAll",
  async () => {
    const { data } = await api.get(
      API_ENDPOINTS.security.securityRulesFunctionality.getAll
    );
    return data;
  }
);

// — Get one functionality rule by its ID (for editing)
export const fetchSecurityRuleFunctionalityById = createAsyncThunk(
  "securityRulesFunctionality/fetchById",
  async (id) => {
    const { data } = await api.get(
      API_ENDPOINTS.security.securityRulesFunctionality.getById + id
    );
    return data;
  }
);

// — Create a new rule
export const createSecurityRuleFunctionality = createAsyncThunk(
  "securityRulesFunctionality/create",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.securityRulesFunctionality.create,
      payload
    );
    return data;
  }
);

// — Update an existing rule
export const updateSecurityRuleFunctionality = createAsyncThunk(
  "securityRulesFunctionality/update",
  async (payload) => {
    const { data } = await api.post(
      API_ENDPOINTS.security.securityRulesFunctionality.update,
      payload
    );
    return data;
  }
);

// — Delete a rule
export const deleteSecurityRuleFunctionality = createAsyncThunk(
  "securityRulesFunctionality/delete",
  async (id) => {
    await api.delete(
      API_ENDPOINTS.security.securityRulesFunctionality.delete + id
    );
    return id;
  }
);
